/* eslint-disable @angular-eslint/directive-selector */
import { Directive } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Directive({ selector: 'ng-template[routerOutlet]', standalone: true })
export class RouterOutletDirective extends RouterOutlet {}
